const dataAccessMethods = require('../../dataAccessMethods');
const { config } = require('@sstdev/lib_metadata-config');
const Blockly = require('blockly');

const baseMdcBlockGroup = require('./_BaseMdcBlockGroup');
class Dialog extends baseMdcBlockGroup {
    addCodeGeneratorCustom(code, blocklyBlock) {
        code.openAction = blocklyBlock.getFieldValue('openAction');
        code.closeAction = blocklyBlock.getFieldValue('closeAction');
        code.namespace = blocklyBlock.getFieldValue('namespace');
        code.relation = blocklyBlock.getFieldValue('relation');
        return JSON.stringify(code);
    }

    addToBlocksCustom(color, blocklyBlock, hNodeType, mdcBlock) {
        blocklyBlock
            .appendDummyInput()
            .setAlign(Blockly.ALIGN_RIGHT)
            .appendField('  Open Action:')
            .appendField(new Blockly.FieldDropdown(config.actionElementActions), 'openAction');
        blocklyBlock
            .appendDummyInput()
            .setAlign(Blockly.ALIGN_RIGHT)
            .appendField('  Close Action:')
            .appendField(new Blockly.FieldDropdown(config.actionElementActions), 'closeAction');
        blocklyBlock
            .appendDummyInput()
            .setAlign(Blockly.ALIGN_RIGHT)
            .appendField('  Namespace:')
            .appendField(new Blockly.FieldDropdown(dataAccessMethods.getNamespaces), 'namespace');
        let blockId = blocklyBlock.id;
        let workspace = blocklyBlock.workspace;
        blocklyBlock
            .appendDummyInput()
            .setAlign(Blockly.ALIGN_RIGHT)
            .appendField('  Relation:')
            .appendField(
                new Blockly.FieldDropdown(() => dataAccessMethods.getRelations(workspace, blockId)),
                'relation'
            );
        blocklyBlock
            .appendStatementInput('children')
            .setCheck(mdcBlock.allowedChildrenTypes)
            .appendField('Children:', 'childrenField');
    }
}
module.exports = Dialog;
